(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AppController', AppController)
 
    AppController.$inject = ["AnalisisService","SerialService","PizarraService","GenerallabService","socket","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AppController(AnalisisService,SerialService,PizarraService,GenerallabService,socket,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        //var noSleep = new NoSleep();
        //noSleep.enable(); // keep the screen on!
        vm.avisos = [];
        vm.timers = {};
        vm.num_chat = 0;
        vm.generalLab = GenerallabService;
        vm.serialInfo = SerialService;
        SerialService.loadPortsFromStorage();

	    //console.log("appcont");
        //console.log("CONNECTION APP")
	    socket.on("pizarra:nuevacartaaviso",function(data){
            //if(vm.esVisibleParaMi(data.carta)){
            	console.log("ES VISIBLE");
                data.carta.type_aviso = data.type_aviso;
                switch(data.carta.type_aviso){
                    case "Chat":
                        vm.generalLab.num_chat++;
                    break;
                    case "Pizarra":
                        vm.generalLab.num_cartas++;
                    break;
                }
            console.log("nuevacarta",data);
            	vm.avisos.push(data.carta);
            	var index = vm.avisos.length-1;
            	vm.timers[data.carta.id] = $timeout(function(){
            		vm.eliminarCarta(data.carta);
            	},30000)
            //}
        })

        vm.connectToPortReader = function() {
            console.log("Connecting to port reader...");
            SerialService.requestPort();
        };

        vm.eliminarCarta = function(carta){
        	var res  = false;
        	for(var cont=0;cont<vm.avisos.length && !res;cont++){
        		if(vm.avisos[cont].id==carta.id){
            		vm.avisos.splice(cont,1);
            		if(vm.timers[carta.id]){
      					$timeout.cancel(vm.timers[carta.id]);
            		}
        		}
        	}
        }

        vm.initVals = function(){
            PizarraService.getUsuarioCartas(function(data){
                vm.generalLab.num_cartas = data.num_cartas;
                vm.generalLab.num_chat = data.mensajesSinLeer;
            })
        }

        vm.init = function(username,categorias_ids,user_lang_id){
            socket.emit('app:login', {id: ""+username});
        	vm.user_id = username;
            vm.generalLab.user_lang_id = user_lang_id;
            socket.emit('pizarra:join', {room:'pizarra',username:username,categorias_ids:categorias_ids});
        	vm.initVals();
	    }

        vm.enviarChatModal = false;
        vm.enviarchat = function(){
          vm.enviarChatModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: 'enviarchat.html',
                  size: 'full',
                  controller: function($scope) {
                    // Función quie inicializa los comentarios para llamarla con ng-change
                    
                    $scope.okForm = function(){
                      vm.initVals();
                      vm.enviarChatModal.close();
                    }
                    $scope.koForm = function(){
                      vm.initVals();
                        vm.enviarChatModal.close();
                    }
                  }
            });

            
        }
        vm.cambiarDatosPeti = function(filtros){
            AnalisisService.cambiarDatosPeticion(filtros,function(data){
                
            })
        }

        /*vm.esVisibleParaMi = function(carta){
            var res = false;
            var categorias_ids = [];
            for(var cont=0;cont<vm.misCategorias.length;cont++){
                categorias_ids.push(""+vm.misCategorias[cont].id);
            }

            console.log(categorias_ids,"cat_ids");
            console.log(carta.categoriapizarra_id,"cat");


            if(categorias_ids.indexOf(""+carta.categoriapizarra_id) !== -1 || carta.user_id==vm.user_id) {
                res = true;
            }
            return res;
        }*/
    }
  
})();